import { connect } from 'react-redux'
import addExistingLayoutSelector from './addExistingLayoutSelector'
import { sagaActions } from '../../../sagas'
import AddExistingLayout from './AddExistingLayout'

export default connect(
  addExistingLayoutSelector,
  {
    requestAddMyLayout: sagaActions.requestAddMyLayout
  }
)(AddExistingLayout)
